import React from 'react'
import TrackVisibility from 'react-on-screen'

// Components import
import About from './About'
import Tech from './Tech'
import Projects from './Projects'
import Contact from './Contact'

const Body = () => {
  return (
    <main className="main-body">
      <TrackVisibility once partialVisibility>
        <About />
      </TrackVisibility>
      <TrackVisibility once partialVisibility>
        <Tech />
      </TrackVisibility>
      <TrackVisibility once partialVisibility>
        <Projects />
      </TrackVisibility>
      <TrackVisibility once partialVisibility>
        <Contact />
      </TrackVisibility>
    </main>
  )
}

export default Body
